import React, { useState } from 'react';
import DataTabs from '../components/molecules/DataTabs';
import LanguageTerminal from '../components/atoms/TabSetComponents/Language&Terminal';
import MerchantPasscode from '../components/atoms/TabSetComponents/MerchantPasscode';
import EmployeeID from '../components/atoms/TabSetComponents/EmployeeID';
import TipConfigration from '../components/atoms/TabSetComponents/TransactionSettings/TipConfigration';
import Surcharge from '../components/atoms/TabSetComponents/TransactionSettings/Surcharge';
import InvoiceNumber from '../components/atoms/TabSetComponents/TransactionSettings/InvoiceNumber';
import TopUpLimit from '../components/atoms/TabSetComponents/TransactionSettings/TopUpLimit';
import Printer from '../components/atoms/TabSetComponents/Printer';
import Sale from '../components/atoms/TabSetComponents/ScreenTimerCounter/sale';
import Refund from '../components/atoms/TabSetComponents/ScreenTimerCounter/Refund';
import { useLocation, useParams } from 'react-router-dom';
import configurationService from '../services/configurationService';
import { useEffect } from 'react';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../Context/authContext';
import Toast from '../components/molecules/Toast';
import Loaders from '../components/atoms/Loaders';
import EmployeeServerMaintenance from '../components/atoms/TabSetComponents/EmployeeServerMaintenance';
const DeviceSetting = () => {
  const { id } = useParams();
  const location = useLocation();

  const [configData, setConfigData] = useState(null);
  const [loader, setLoader] = useState(true);

  const { fetch, refetch } = useContextHook(AuthContext, v => ({
    fetch: v.fetch,
    refetch: v.refetch,
  }));

  useEffect(() => {
    async function config() {
      try {
        const { data, loading } = await configurationService.getConfiguration(id, fetch);
        setConfigData(data);
        setLoader(loading);
      } catch (error) {
        console.log(error.message);
      }
    }

    config();
  }, [id, fetch]);

  const onSubmit = async payload => {
    try {
      await configurationService.updateConfiguration(payload);
      Toast({
        message: 'Your changes will be applied shortly.',
        type: 'success',
      });
      refetch();
    } catch (error) {
      Toast({
        type: 'error',
        message: error?.message,
      });
    }
  };

  return (
    <div>
      {loader ? (
        <Loaders viewLoader />
      ) : (
        <DataTabs
          data={[
            {
              label: 'Terminal Configuration',
              content: (
                <DataTabs
                  verticalTabs
                  rounded
                  data={[
                    {
                      label: 'Language & Terminal Mode',
                      content: (
                        <LanguageTerminal
                          title="Language & Terminal Mode"
                          data={configData?.configuration?.terminal_configuration?.language_and_terminal_mode}
                          completeData={configData}
                          deviceId={location?.state}
                          onSubmit={onSubmit}
                        />
                      ),
                    },
                    {
                      label: 'Employee Server Maintenance',
                      content: (
                        <EmployeeServerMaintenance
                          title={'Employee Server Maintenance'}
                          data={configData?.configuration?.terminal_configuration?.employee_server_maintenance}
                          completeData={configData}
                          deviceId={location?.state}
                          onSubmit={onSubmit}
                        />
                      ),
                    },
                    {
                      label: 'Merchant Passcode',
                      content: (
                        <MerchantPasscode
                          title="Merchant Passcode"
                          data={configData?.configuration?.terminal_configuration?.merchant_passcode}
                          completeData={configData}
                          deviceId={location?.state}
                          onSubmit={onSubmit}
                        />
                      ),
                    },
                    {
                      label: 'Employee ID',
                      content: (
                        <EmployeeID
                          title="Employee ID"
                          data={configData?.configuration?.terminal_configuration?.employee_id}
                          completeData={configData}
                          deviceId={location?.state}
                          onSubmit={onSubmit}
                        />
                      ),
                    },
                  ]}
                />
              ),
            },
            {
              label: 'Transaction Settings',
              content: (
                <DataTabs
                  verticalTabs
                  rounded
                  data={[
                    {
                      label: 'Tip Configuration',
                      content: (
                        <TipConfigration
                          title="Tip Configuration"
                          data={configData?.configuration?.transaction_settings?.tip_configuration}
                          completeData={configData}
                          deviceId={location?.state}
                          onSubmit={onSubmit}
                        />
                      ),
                    },
                    {
                      label: 'Surcharge',
                      content: (
                        <Surcharge
                          title={'Surcharge'}
                          data={configData?.configuration?.transaction_settings?.surcharge}
                          completeData={configData}
                          deviceId={location?.state}
                          onSubmit={onSubmit}
                        />
                      ),
                    },
                    {
                      label: 'Invoice Number',
                      content: (
                        <InvoiceNumber
                          title="Invoice Number"
                          data={configData?.configuration?.transaction_settings?.invoice_number}
                          completeData={configData}
                          deviceId={location?.state}
                          onSubmit={onSubmit}
                        />
                      ),
                    },
                    {
                      label: 'Tap Limit',
                      content: (
                        <TopUpLimit
                          title="Tap Limit"
                          data={configData?.configuration?.transaction_settings}
                          completeData={configData}
                          deviceId={location?.state}
                          onSubmit={onSubmit}
                        />
                      ),
                    },
                  ]}
                />
              ),
            },
            {
              label: 'Printer',
              content: (
                <Printer
                  childBorder
                  title="Printer Settings"
                  data={configData?.configuration?.printer}
                  completeData={configData}
                  deviceId={location?.state}
                  onSubmit={onSubmit}
                />
              ),
            },
            {
              label: 'Screen Time/Counter',
              content: (
                <DataTabs
                  verticalTabs
                  rounded
                  data={[
                    {
                      label: 'Sale',
                      content: (
                        <Sale
                          title="Sale"
                          data={configData?.configuration?.screen_times?.credit_debit_sale}
                          completeData={configData}
                          deviceId={location?.state}
                          onSubmit={onSubmit}
                        />
                      ),
                    },
                    {
                      label: 'Refund',
                      content: (
                        <Refund
                          title={'Refund'}
                          data={configData?.configuration?.screen_times?.refund}
                          completeData={configData}
                          deviceId={location?.state}
                          onSubmit={onSubmit}
                        />
                      ),
                    },
                  ]}
                />
              ),
            },
          ]}
        />
      )}
    </div>
  );
};

export default DeviceSetting;
